import { EnvironmentGroupId } from '@/react/portainer/environments/types';

import { AccessPolicyValue } from '../rbac/types';

/**
 * API payload for Docker Registry Policy
 * Uses PascalCase to match backend expectations
 */
export interface DockerRegistryPolicyPayload {
  RegistryAccessPolicies: Record<
    // registry ID
    string,
    // user and team ids with access to the registry
    {
      UserAccessPolicies: Record<string, AccessPolicyValue>;
      TeamAccessPolicies: Record<string, AccessPolicyValue>;
    }
  >;
}

/**
 * Complete form values for Docker Registry Policy form.
 * Combines common policy fields (name, environmentGroupIds) with type-specific fields.
 * This is the type used by Formik in DockerRegistryPolicyForm.
 */
export interface DockerRegistryFormValues {
  /** Policy name */
  name: string;
  /** Environment groups to apply the policy to */
  environmentGroupIds: Array<EnvironmentGroupId>;
  /** Registry access rows - one row per registry with user/team access */
  accessRows: Array<{
    id: number;
    registryId: number | null;
    userIds: Array<number>;
    teamIds: Array<number>;
  }>;
}

/**
 * Default initial values for complete Docker Registry Policy form (create mode)
 */
export const DOCKER_REGISTRY_FORM_INITIAL_VALUES: DockerRegistryFormValues = {
  name: '',
  environmentGroupIds: [],
  accessRows: [],
};
